import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';

export class DocumentCategoryDto extends BaseDto {
  name?: string;
  merchants: MerchantDto[];
}
